export enum Role {
  Admin = 'SuperAdmin1',
  None = "None",
}
